var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"timeline"},on:{"click":_vm.onClick}},[_c('div',{ref:"timeLoaded",attrs:{"id":"timeline--loaded"}}),_c('div',{ref:"timeElapsed",attrs:{"id":"timeline--elapsed"}}),_c('div',{ref:"timePoint",attrs:{"id":"timeline--point"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }